(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sold-progress-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sold-progress-bar')) {
    class SoldProgressBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.valueElement = this.querySelector('[data-sold-progress-value]');
        this.trackElement = this.querySelector('[role="progressbar"]');
        this.startValue = this.clamp(Number(this.dataset.start));
        this.endValue = this.clamp(Number(this.dataset.end));
        this.duration = Math.max(0, Number(this.dataset.duration) || 0);
        this.style.setProperty('--sold-progress-current', `${this.startValue}%`);
        this.renderValue(this.startValue);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.finish();
          return;
        }

        if (!('IntersectionObserver' in window)) {
          this.startAnimation();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;

            this.observer.disconnect();
            this.startAnimation();
          },
          { threshold: 0.35 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      }

      clamp(value) {
        if (!Number.isFinite(value)) return 0;
        return Math.min(100, Math.max(0, value));
      }

      renderValue(value) {
        const roundedValue = Math.round(value);
        if (this.valueElement) this.valueElement.textContent = roundedValue;
        if (this.trackElement) this.trackElement.setAttribute('aria-valuenow', String(roundedValue));
      }

      startAnimation() {
        if (this.hasStarted) return;
        this.hasStarted = true;
        this.classList.add('is-animating');

        if (this.duration === 0 || this.startValue === this.endValue) {
          this.finish();
          return;
        }

        const startedAt = performance.now();
        const animate = (now) => {
          const progress = Math.min((now - startedAt) / this.duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 4);
          const currentValue = this.startValue + (this.endValue - this.startValue) * easedProgress;

          this.style.setProperty('--sold-progress-current', `${currentValue}%`);
          this.renderValue(currentValue);

          if (progress < 1) {
            this.animationFrame = requestAnimationFrame(animate);
          } else {
            this.finish();
          }
        };

        this.animationFrame = requestAnimationFrame(animate);
      }

      finish() {
        this.style.setProperty('--sold-progress-current', `${this.endValue}%`);
        this.renderValue(this.endValue);
        this.classList.remove('is-animating');
      }
    }

    customElements.define('sold-progress-bar', SoldProgressBar);
  }
  } catch(e) { console.error(e); }
})();

})();
